import config from './config.json';

export default {
  apiGateway: {
    URL: config.ApiGateway,
  },
  cognito: {
    AWS_REGION: 'eu-central-1',
    USER_POOL_ID: config.UserPoolId,
    APP_CLIENT_ID: config.AppClientId,
  },
};



// WEBPACK FOOTER //
// ./src/config.js